define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/jquery/src/var/document.js
// module id = 17
// module chunks = 1